import { getCookie } from 'utils/storage';

export function getStatusBarSizes(): {
  topStatusBarSize: number;
  bottomStatusBarSize: number;
} {
  /**
   * Workaround for version 6.5.1
   * Can be remove this if committed more than 8 months,
   * since the usage will be significantly low
   */
  if (getCookie('version') === '6.5.1') {
    return {
      topStatusBarSize: 0,
      bottomStatusBarSize: 0,
    };
  }

  return {
    topStatusBarSize: Number(getCookie('topPaddingSize')) || 0,
    bottomStatusBarSize: Number(getCookie('bottomPaddingSize')) || 0,
  };
}
